import { createSelector } from "reselect";
import { studiesResourceSelectors } from "../studies_resource_selectors";

/**
 * Creates a selector that gets the study for a patient
 * @param {string} patientId
 * @return {Function} selector
 */
export function createStudyForPatientIdSelector(patientId) {
  return createSelector(
    studiesResourceSelectors.dataSelector,
    studies => {
      return Object.values(studies).find(study => {
        return study.attributes.patientId == patientId;
      });
    }
  );
}
